import { PluginHeaderActionBlueprint } from '@backstage/frontend-plugin-api';

// Note: to be used in scaffolder plugin override
export * from './scaffolder-landing-page';
export * from './scaffolder-landing-page-tabbed';
export {
  SCAFFOLDER_PAGE_HEADER_TITLE,
  SCAFFOLDER_PAGE_HEADER_OPTIONS,
} from './constants';

// Installed on the scaffolder plugin (see packages/app/src/overrides/scaffolder-plugin.tsx)
export const scaffolderHeaderActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () => import('./header-actions').then(m => <m.HeaderActions />),
    }),
});
